import React from "react";
import {
  Route,
  Switch,
  Redirect,
  useParams,
  useRouteMatch,
} from "react-router";
import List from "./List";
import { FormCreatev2 } from "../../forms/formBuilder"

const Forms = () => {
  const params: any = useParams();
  const match: any = useRouteMatch();
  const redirectUrl = match.path.replace(":appId", params.appId) + "/list"

  return (
    <Switch>
      <Route exact path={`${match.path}/list/:formId/create`} component={FormCreatev2} />
      <Route exact path={`${match.path}/list`} component={List} />
      <Route component={() => <Redirect to={redirectUrl} />} />
    </Switch>
  );
};

export default Forms;
